import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { I18n, NgtLinkComponent } from '@corporate/ng-tebis-base-components';
import { AssistantMessageComponent } from '../../../assistant/assistant-message/assistant-message.component';
import { WindowedRouterLinkComponent } from '../../../../01_core/windowed-router-link/windowed-router-link.component';
import { AIForm } from '../../../../03_model/ai-chat-message.model';

export type OrderCreatedData = {
  orderID: string;
  sentDate: Date;
}

@Component({
  selector: 'tps-order-created-message',
  imports: [
    AssistantMessageComponent,
    WindowedRouterLinkComponent,
    NgtLinkComponent,
  ],
  templateUrl: './order-created-message.component.html',
  styleUrl: './order-created-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderCreatedMessageComponent implements AIForm {

  i18n = inject(I18n);

  data = input.required<OrderCreatedData>();
  update = input.required<(newData: any) => void>();

  constructor() {
    this.i18n.addNamespace('assistant');
  }

  getOrderTabLabel(name: string) {
    return signal(name);
  }
}
